import { render } from "./hub.vue?vue&type=template&id=54686b18"
import script from "./hub.vue?vue&type=script&lang=js"
export * from "./hub.vue?vue&type=script&lang=js"

import "./hub.vue?vue&type=style&index=0&id=54686b18&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__